function isDisabled(link) {
  return link.classList.contains("disabled") || link.classList.contains("active")
}

export default class extends Controller {
  connect() {
    this.loadPage = this.loadPage.bind(this);
    [...this.element.querySelectorAll('.pagination li a')].forEach(el => {
      el.addEventListener("click", this.loadPage)
    })
  }

  loadPage(event) {
    !isDisabled(event.currentTarget) && App.replaceTabContentOnClick(event, this.targetSelector)
  }


  //
  // GETTERS AND SETTERS
  //

  get targetSelector() {
    return this.data.get("target-selector");
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/pagination-controller.js